import { render, staticRenderFns } from "./MapIconWordClass.vue?vue&type=template&id=da40434e&scoped=true&"
import script from "./MapIconWordClass.vue?vue&type=script&lang=js&"
export * from "./MapIconWordClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da40434e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da40434e')) {
      api.createRecord('da40434e', component.options)
    } else {
      api.reload('da40434e', component.options)
    }
    module.hot.accept("./MapIconWordClass.vue?vue&type=template&id=da40434e&scoped=true&", function () {
      api.rerender('da40434e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconWordClass.vue"
export default component.exports